(function ($) {
  var $body = $('body'), rtl = $body.hasClass('rtl-layout'), win = window, $win = $(win), custEl = customElements,
  checkVisible = ($el) => {
    var cond1 = ($el.get(0).offsetWidth > 0) && ($el.get(0).offsetHeight > 0),
    cond2 = ($el.is(':visible')),
    winTop = window.pageYOffset,
    winBot = winTop + window.innerHeight,
    elTop = $el.offset().top,
    elHeight = $el.outerHeight(true),
    elBot = elTop + elHeight,
    cond3 = (elTop <= winTop) && (elBot >= winTop),
    cond4 = (elTop >= winTop) && (elTop <= winBot),
    cond5 = (elTop >= winTop) && (elBot <= winBot),
    cond6 = (elTop <= winBot) && (elBot >= winBot);
    return cond1 && cond2 && (cond3 || cond4 || cond5 || cond6);
  }
  if (!custEl.get('cdz-facet-color')) {
    custEl.define('cdz-facet-color', class CdzFacetColor extends HTMLElement {
      constructor() {
        super();
        this.element = $(this);
        this.prepareHtml();
      }
      prepareHtml() {
        var label = this.element.data('name'), title = this.element.attr('title'), match = window.cdzCore.getColorMap()[label], bkg = '';
        if (match) {
          if (match.color) bkg += ' ' + match.color; 
          if (match.background) bkg += ' url("' + match.background + '")';
        }
        this.element.css('--gb-sw-bkg', bkg).tooltip({
          items: ".facet-color",
          position: {my: "center bottom-5", at: "center top"},
          content: function() {
            return '<div class="cdz-tooltip sw-tooltip" style=\'--gb-sw-bkg:'+bkg+'\'><div class="sw-bkg"></div><div class="sw-label">'+title+'</div></div>';
          }
        });
      }
    });
  }
  if (!custEl.get('cdz-price-slider')) {
    custEl.define('cdz-price-slider', class CdzPriceSlider extends HTMLElement {
      constructor() {
        super();
        this.element = $(this);
        this.prepareHtml();
      }
      prepareHtml() {
        var self = this, $el = this.element;
        this.$slider = $el.find('[role="slider"]');
        this.min = Number($el.data('min'));
        this.max = Number($el.data('max'));
        this.$min = $el.find('[role="cur_min"]');
        this.$max = $el.find('[role="cur_max"]');
        this.curMin = this.$min.val() ? Number(this.$min.val()) : this.min;
        this.curMax = this.$max.val() ? Number(this.$max.val()) : this.max;
        this.$form = $el.parents('form').first();
        this.$slider.slider({
          range: true,
          min: this.min,
          max: this.max,
          values: [this.curMin, this.curMax],
          slide: function(event, ui) {
            if (self.curMin != ui.values[0]) {
              self.$min.val(ui.values[0]).attr('min', ui.values[0]);
            }
            if (self.curMax != ui.values[1]) {
              self.$max.val(ui.values[1]).attr('max', ui.values[1]);
            }
          },
          stop: function(event, ui) {
            var change = false;
            if (self.curMin != ui.values[0]) {
              self.curMin = ui.values[0];
              self.$min.get(0).dispatchEvent(new Event('input', {bubbles:true}));
            }
            if (self.curMax != ui.values[1]) {
              self.curMax = ui.values[1];
              self.$max.get(0).dispatchEvent(new Event('input', {bubbles:true}));
            }
          }
        });
      }
    });
  }
  if (!custEl.get('cdz-list-more')) {
    custEl.define('cdz-list-more', class CdzListMore extends HTMLElement {
      options = {
        grid: '#product-grid',
        nextLink: '.collection .pagination a.pagination__item--prev',
        prevLink: '.collection .pagination a.pagination__item--next',
        pagination: '.pagination-wrapper'
      }
      constructor() {
        super();
        this.element = $(this);
        this.options = $.extend(this.options, this.dataset);
        this.$loader = $('[role="loader"]', this);
        this.processing = false;
        if (typeof win.cdzLoadMorePages == 'undefined') {
          win.cdzLoadMorePages = [ $(this.options.grid).children().first().attr('data-page', document.URL) ];
        }
        this.events();
      }
      events() {
        var self = this, conf = this.options, $firstPage = $(conf.grid).children().first();
        this.element.on('click', '[role=collection_load_more]', function(e) {
          if (self.processing) return;
          self.processing = true; self.element.addClass('loading');
          e.preventDefault();
          var $btn = $(this), $grid = $(conf.grid), $page = $(conf.pagination);
          if (conf.dir == 'prev') {
            conf.curpage = parseInt(conf.curpage) - 1;
            var ajaxUrl = document.URL.replaceAll(/page=(\d+)/g, 'page=' + conf.curpage);
          } else {
            var ajaxUrl = $(conf.nextLink).attr('href');
          }
          $btn.attr('disabled', 'disabled'); self.$loader.fadeIn(500);
          $.ajax({
            url: ajaxUrl,
            data: {section_id: self.dataset.section},
            type: 'get',
            success: (rs) => {
              var $pool = $('<div>').html(rs), $children = $pool.find(conf.grid).children();
              if (conf.dir == 'prev') {
                $children.prependTo($grid);
              } else {
                $children.appendTo($grid);
              }
              win.cdzLoadMorePages.push($children.first().attr('data-page', ajaxUrl));
              $pool.find(conf.pagination).insertAfter($page);
              $page.remove();
              $pool.remove();
              $btn.removeAttr('disabled');
              self.$loader.fadeOut(500);
              win.history.replaceState({},"", ajaxUrl);
              if ((conf.dir != 'prev') && !$(conf.nextLink).length || (conf.curpage == 1)) {
                self.element.remove();
              }
              self.element.removeClass('loading');
              self.processing = false;
            }
          })
        });
        if (!win.cdzLoadMoreInterval) {
          win.cdzLoadMoreInterval = setInterval(() => {
            $.each(win.cdzLoadMorePages, (i, $page) => {
              if (checkVisible($page)) {
                win.history.replaceState({},"", $page.data('page'));
                return false;
              }
            });
            $win.trigger('cdzLoadMoreEvents');
          }, 500);
        }
      }
    });
  }
  if (!custEl.get('cdz-infinite-scroll')) {
    custEl.define('cdz-infinite-scroll', class CdzListMoreAuto extends HTMLElement {
      options = {
        loadMore: 'cdz-list-more[data-dir=next]'
      }
      constructor() {
        super();
        this.element = $(this);
        this.options = $.extend(this.options, this.dataset);
        this.$more = $(this.options.loadMore);
        this.events();
      }
      events() {
        var t = false, self = this;
        $win.on('cdzLoadMoreEvents.infinite', () => {
          if (t) clearTimeout(t);
          t = setTimeout(() => {
            if (self.$more.length && checkVisible(self.$more)) {
              if (!self.$more.hasClass('loading'))
                self.$more.find('button:not(:disabled)').trigger('click');
            }
            if (!self.$more.length) {
              $win.off('cdzLoadMoreEvents.infinite');
            }
          }, 50);
        });
      }
    });
  }
})(jQuery)